import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import React, { useEffect, useRef, useState } from 'react';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaPaperPlane } from 'react-icons/fa';
import './contact.css';

function AppContact() {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setVisible(entry.isIntersecting),
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      id="contact"
      className="block contact-block"
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(60px)',
        transition: 'opacity 0.7s ease, transform 0.7s ease',
        pointerEvents: visible ? 'auto' : 'none',
        padding: '80px 0',
        backgroundColor: '#fff',
        overflow: 'hidden' // Adicionado para prevenir qualquer overflow
      }}
    >
      <Container>
        <div className="section-header text-center mb-5">
          <h2 className="section-title" style={{
            color: '#00761F',
            fontWeight: '700',
            fontSize: '2.5rem',
            textTransform: 'uppercase',
            marginBottom: '15px',
            position: 'relative',
            display: 'inline-block'
          }}>
            Contacte-nos
            <span style={{
              position: 'absolute',
              bottom: '-10px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '80px',
              height: '4px',
              backgroundColor: '#00761F',
              borderRadius: '2px'
            }}></span>
          </h2>
          <p className="section-subtitle" style={{
            color: '#555',
            fontSize: '1.1rem',
            maxWidth: '700px',
            margin: '0 auto',
            lineHeight: '1.6'
          }}>
            Tem alguma questão ou sugestão? Preencha o formulário abaixo e entraremos em contacto consigo brevemente.
          </p>
        </div>

        <Row className="align-items-center">
          <Col lg={6} className="mb-5 mb-lg-0">
            <div className="contact-info-card p-4 p-lg-5" style={{
              backgroundColor: '#f9f9f9',
              borderRadius: '15px',
              height: '100%',
              boxShadow: '0 5px 15px rgba(0,0,0,0.05)',
              overflow: 'hidden' // Previne overflow interno
            }}>
              <h3 style={{
                color: '#00761F',
                marginBottom: '30px',
                fontSize: '1.5rem',
                fontWeight: '600'
              }}>Informações de Contacto</h3>
              
              <div className="contact-item d-flex mb-4">
                <div className="icon-box me-4" style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  backgroundColor: '#e8f5e9',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <FaEnvelope style={{ color: '#00761F', fontSize: '1.5rem' }} />
                </div>
                <div style={{ width: '100%', maxWidth: '100%', overflow: 'hidden' }}>
                  <h4 style={{
                    color: '#333',
                    fontSize: '1.1rem',
                    marginBottom: '5px',
                    fontWeight: '600'
                  }}>Email</h4>
                  <p style={{ 
                    color: '#666', 
                    margin: 0, 
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word'
                  }}>secretariageral@ispatlantida.co.ao</p>
                </div>
              </div>

              <div className="contact-item d-flex mb-4">
                <div className="icon-box me-4" style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  backgroundColor: '#e8f5e9',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <FaPhone style={{ color: '#00761F', fontSize: '1.5rem' }} />
                </div>
                <div style={{ width: '100%', maxWidth: '100%' }}>
                  <h4 style={{
                    color: '#333',
                    fontSize: '1.1rem',
                    marginBottom: '5px',
                    fontWeight: '600'
                  }}>Telefone</h4>
                  <p style={{ color: '#666', margin: 0 }}>+244 929 282 704</p>
                </div>
              </div>

              <div className="contact-item d-flex">
                <div className="icon-box me-4" style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  backgroundColor: '#e8f5e9',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <FaMapMarkerAlt style={{ color: '#00761F', fontSize: '1.5rem' }} />
                </div>
                <div style={{ width: '100%', maxWidth: '100%' }}>
                  <h4 style={{
                    color: '#333',
                    fontSize: '1.1rem',
                    marginBottom: '5px',
                    fontWeight: '600'
                  }}>Localização</h4>
                  <p style={{ 
                    color: '#666', 
                    margin: 0,
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word'
                  }}>Benfica, Estrada Lar do Patriota, Junto a Rua 14, Luanda, Angola</p>
                </div>
              </div>
            </div>
          </Col>

          <Col lg={6}>
            <Form className="contact-form p-4 p-lg-5" style={{
              backgroundColor: '#fff',
              borderRadius: '15px',
              boxShadow: '0 5px 15px rgba(0,0,0,0.05)',
              overflow: 'hidden' // Previne overflow interno
            }}>
              <Form.Group className="mb-4">
                <Form.Control
                  type="text"
                  placeholder="Seu nome completo"
                  required
                  style={{
                    padding: '15px',
                    borderRadius: '10px',
                    border: '1px solid #ddd',
                    maxWidth: '100%'
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Control
                  type="email"
                  placeholder="Seu endereço de email"
                  required
                  style={{
                    padding: '15px',
                    borderRadius: '10px',
                    border: '1px solid #ddd',
                    maxWidth: '100%'
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Control
                  type="tel"
                  placeholder="Seu número de telefone"
                  style={{
                    padding: '15px',
                    borderRadius: '10px',
                    border: '1px solid #ddd',
                    maxWidth: '100%'
                  }}
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Control
                  as="textarea"
                  rows={5}
                  placeholder="Sua mensagem"
                  required
                  style={{
                    padding: '15px',
                    borderRadius: '10px',
                    border: '1px solid #ddd',
                    maxWidth: '100%'
                  }}
                />
              </Form.Group>

              <Button
                type="submit"
                className="w-100"
                style={{
                  padding: '15px',
                  backgroundColor: '#00761F',
                  border: 'none',
                  borderRadius: '10px',
                  fontWeight: '600',
                  fontSize: '1rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px',
                  maxWidth: '100%'
                }}
              >
                <FaPaperPlane /> Enviar Mensagem
              </Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default AppContact;